import React, {useContext} from "react";
import {makeStyles, Typography, Button} from "@material-ui/core";
import {AuthContext} from '../context/Authcontext';

import LogOut from "../assets/Configuracoes/Icon ionic-md-exit@2x.png";

export default function Logout(){
  const classes = useStyles();
  const {logout} = useContext(AuthContext); 
  const handleLogout = async (e) => {
    logout()
  }
  return(
    <div className={classes.root}>
      <Typography className={classes.tituloD}>ADMINISTRADOR</Typography>
      <Typography className={classes.tituloM}>ADMINISTRADOR</Typography>
      <Button className={classes.LogOutbutton} onClick={handleLogout}>
        <img src={LogOut} alt="LogOut" className={classes.LogOut}/>
      </Button>
      <Button className={classes.LogOutbuttonM} onClick={handleLogout}>
        <img src={LogOut} alt="LogOut" className={classes.LogOut}/>
      </Button>
    </div>
  )
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    display: "flex",
  },
  LogOut: {
    height: "27px",
  },
  tituloD: {
    marginTop: "54px",
    font: "Rubik",
    fontSize: "48px",
    color: theme.colors.gray1,
    marginLeft: "3.7vw",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  tituloM: {
    marginTop: "16px",
    font: "Rubik",
    fontSize: "24px",
    color: theme.colors.gray1,
    alignSelf: "flex-start",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  LogOutbutton: {
    marginTop: "54px",
    marginRight: "20px",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  LogOutbuttonM: {
    marginTop: "16px",
    marginRight: "10px",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
}));